import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel,
  confirmColor,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered>
      <ModalHeader toggle={onCancel}>{title || 'Confirmação'}</ModalHeader>
      <ModalBody>
        <div style={{ fontSize: '14px', color: '#3d3d3a' }}>{message}</div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="new-layout-btn main"
          color="light"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button
          className="new-layout-btn main"
          color={confirmColor || 'primary'}
          onClick={onConfirm}
        >
          {confirmLabel || 'Confirmar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
